import React, { memo } from 'react';
import * as S from './styled';
import { getDirectParentFromBreadcrumbs } from '../../../../utils/breadcrumbs';
export const CategoryValue = memo(({ selectedCategory, showParent = true }) => {
    const directParent = showParent
        ? getDirectParentFromBreadcrumbs(selectedCategory?.breadcrumbs || [])
        : null;
    return (React.createElement(S.Value, null,
        selectedCategory?.name || '',
        directParent && (React.createElement("span", null,
            ` `,
            "in ",
            directParent))));
});
